<template>
  <van-popup v-model:show="show" position="center" :style="{ background: 'transparent' }">
    <div class="deposit-popup">
      <!-- Header -->
      <!-- <div class="popup-header">
        <span>{{ t('common.deposite') }}</span>
      </div> -->
      <div class="popup-header">
        <van-row style="display: flex;align-items: center;">
          <van-col span="22">
            <span>{{ $t('common.deposite') }}</span>
          </van-col>
          <van-col span="2">
            <img src="@/assets/profile/cs_close_n.png" alt="" width="20" @click="close" />
          </van-col>
        </van-row>
      </div>

      <!-- Content -->
      <div class="popup-content">
        <div class="iframe-container">
          <iframe :src="iframeUrl" frameborder="0"></iframe>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import { ref, defineExpose } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const show = ref(false)
const iframeUrl = ref('')

const open = (url: string) => {
  iframeUrl.value = url
  show.value = true
}

const close = () => {
  show.value = false
}

defineExpose({
  open,
  close
})
</script>

<style scoped>
.deposit-popup {
  /* width: 90%; */
  max-width: 100%;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
}

/* Header */
.popup-header {
  background: linear-gradient(90deg, #c854ad 0%, #432e4f 100%);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  padding: 14px;
}

/* Content */
.popup-content {
  background-color: #392942;
  padding: 10px;
}

.popup-content::-webkit-scrollbar {
  display: none;
}


.van-popup--center {
  top: 50%;
  left: 0;
  right: 0;
  width: unset;
  margin: 0 7.5%;
  transform: translateY(-50%);
}

/* Iframe Container */
.iframe-container {
  background: #fff;
  border-radius: 12px;
  /* padding: 10px; */
  overflow: hidden;
}

.iframe-container iframe {
  width: 100%;
  height: 60vh;
  border: none;
  border-radius: 8px;
}

/* Close icon styling */
.van-popup__close-icon {
  color: #fff;
  top: 12px;
  right: 12px;
}

.van-overlay {
  backdrop-filter: blur(.26667rem);
  background: #000000b3;
}
</style>
